import { Fragment, ReactNode } from 'react';

import styles from './CarouselModalContent.module.scss';

interface ICarouselModalContentItem {
  heading: string;
  paragraph: string | ReactNode;
}

interface ICarouselModalContent {
  content: ICarouselModalContentItem[];
  image: {
    desktop: string;
    mobile: string;
  };
}

export const CarouselModalContent = ({ content = [], image }: ICarouselModalContent) => (
  <div className={styles.root}>
    <div className={styles.content}>
      {content.map(({ heading, paragraph }: ICarouselModalContentItem, index: number) => (
        <Fragment key={`${heading}-${index}`}>
          <h2 className={styles.heading}>{heading}</h2>
          <p className={styles.paragraph}>{paragraph}</p>
        </Fragment>
      ))}
    </div>
    <div className={styles.image}>
      <img alt="Value proposition" className={styles['image-desktop']} src={image.desktop} />
      <img alt="Value proposition" className={styles['image-mobile']} src={image.mobile} />
    </div>
  </div>
);
